<div class="wrapper">
  <div class="heading text-type-5">{{ data?.bidItem?.item }}</div>
  <div class="description text-type-10">{{ data?.bidItem?.description }}</div>
  <div class="uom text-type-14">UOM: {{ data?.bidItem?.uom }}</div>
  <div class="entries summary-status text-type-15 mt-[10px]">
    @if (data?.isAnyLinePaid) {
      <span class="paid-badge summary-badge">PAID</span>
      <span class="summary-dot">•</span>
    }
    @if (data?.totalLineItemCount > 0) {
      <span class="summary-text">
        {{ data.isAnyLinePaid && data.paidLineItemCount !== data.totalLineItemCount ? data.paidLineItemCount + '/' + data.totalLineItemCount : data.totalLineItemCount }}
        {{ data.totalLineItemCount === 1 ? 'entry' : 'entries' }}
      </span>
    }
    @if (data?.totalLineItemCount === 0) {
      <span class="summary-text">0 entries</span>
    }
    @if (displayMatched) {
      <span class="matched text-type-15">{{ matchedNo }} {{ matchedNo > 1 ? 'occurrences' : 'occurrence' }}</span>
    }
  </div>
  @if (linkedLineItemCount) {
    <div class="card-linked-count text-type-14" data-testid="design-context-linked-count">{{ linkedCountText(linkedLineItemCount) }}</div>
  }
</div>
